import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";

export default function NotFound() {
  return (
    <div className="grid min-h-screen place-items-center bg-[#FDFBF7] p-6 text-center">
      <div>
        <div className="mx-auto w-fit">
          <Logo />
        </div>
        <h1 className="font-display mt-8 text-6xl font-extrabold text-[#FF6D47]">404</h1>
        <p className="mt-3 font-bold text-[#6E6259]">Esta página saiu para passear... mas nenhuma patinha a encontrou.</p>
        <Link
          to="/"
          className="mt-8 inline-flex h-12 items-center gap-2 rounded-full bg-[#FF6D47] px-7 font-extrabold text-white transition hover:bg-[#E85732]"
        >
          <ArrowLeft className="h-4 w-4" /> Voltar para a home
        </Link>
      </div>
    </div>
  );
}
